import { Component, Input } from '@angular/core';
import { CardBadgeKind, IRecordCard } from '../../driver-background-check.view-models';

@Component({
  selector: 'app-bgc-section-permits',
  templateUrl: './bgc-section-permits.component.html',
  styleUrls: ['./bgc-section-permits.component.scss', '../../driver-background-check.component.scss']
})
export class BgcSectionPermitsComponent {
  @Input() cards: IRecordCard[] = [];

  trackByCard(index: number, card: IRecordCard): string {
    return card.id;
  }

  badgeClass(kind: CardBadgeKind): string {
    return `badge-kind-${kind}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/driver-background-check/components/bgc-section-permits/bgc-section-permits.component.ts